import type { Entity as CartItemEntity } from '@mathflat/domain/@entities/PODMall/CartItem/dto'
import type { PODApi as PODMallPaymentApi } from '@mathflat/domain/@entities/PODMall/Payment/api'
import { makeAutoObservable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'

export class CartItemStudent {
  _id: string
  name: string
  studentId: string
  printingUserName: string
  parentPhoneNumber: string

  constructor({
    _id,
    name,
    studentId,
    printingUserName,
    parentPhoneNumber,
  }: Partial<CartItemStudent> = {}) {
    makeAutoObservable(this)

    this._id = _id ?? uuidv4()
    this.name = name ?? ''
    this.studentId = studentId ?? ''
    this.printingUserName = printingUserName ?? name ?? ''
    this.parentPhoneNumber = parentPhoneNumber ?? ''
  }

  toParentOrders(): NonNullable<CartItemEntity.CartItem['parentOrders']>[number] {
    return {
      studentId: this.studentId,
      parentPhoneNumber: this.parentPhoneNumber,
      studentName: this.name,
      printingUserName: this.printingUserName,
    }
  }

  get toParentOrderParams(): PODMallPaymentApi.Request.ParentPaymentSend_v2['parentOrderItems'][number]['parentOrders'][number] {
    return {
      parentPhoneNumber: this.parentPhoneNumber,
      studentName: this.name,
      printingUserName: this.printingUserName,
    }
  }
}
